import React from 'react';
import { Search, Calendar, Wrench, CheckCircle, ArrowRight } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Search className="h-8 w-8 text-white" data-id="element-269" />,
    title: 'Choose a Service',
    description: 'Select the service you need - painting, waterproofing, or micro-repairs.'
  }, {
    icon: <Calendar className="h-8 w-8 text-white" data-id="element-270" />,
    title: 'Book Your Appointment',
    description: "Pick a date and time that works for you. We'll match you with a certified professional."
  }, {
    icon: <Wrench className="h-8 w-8 text-white" data-id="element-271" />,
    title: 'Get It Done',
    description: 'Our trained professional will arrive and complete your service with quality materials.'
  }, {
    icon: <CheckCircle className="h-8 w-8 text-white" data-id="element-272" />,
    title: 'Enjoy Peace of Mind',
    description: "All work comes with a warranty. We'll follow up to ensure you're completely satisfied."
  }];
  return <section id="how-it-works" className="py-16 bg-white" data-id="element-273">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
        <div className="text-center max-w-3xl mx-auto" data-id="element-275">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-276">
            How It Works
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-277">
            Getting your home serviced is simple with Smart Homebox
          </p>
        </div>
        <div className="mt-16 max-w-5xl mx-auto" data-id="element-278">
          {/* Desktop view - horizontal steps with connecting lines */}
          <div className="hidden lg:block" data-id="element-279">
            <div className="relative" data-id="element-280">
              <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2" data-id="element-281"></div>
              <div className="flex justify-between relative z-10" data-id="element-282">
                {steps.map((step, index) => <div key={index} className="flex flex-col items-center w-64" data-id="element-283">
                    <div className="flex-shrink-0 h-16 w-16 rounded-full bg-primary flex items-center justify-center mb-4" data-id="element-284">
                      {step.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 text-center mb-2" data-id="element-285">
                      {step.title}
                    </h3>
                    <p className="text-center text-gray-600" data-id="element-286">
                      {step.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Mobile and tablet view - vertical steps with arrows */}
          <div className="lg:hidden space-y-8" data-id="element-287">
            {steps.map((step, index) => <div key={index} data-id="element-288">
                <div className="flex items-start" data-id="element-289">
                  <div className="flex-shrink-0 h-14 w-14 rounded-full bg-primary flex items-center justify-center mr-4" data-id="element-290">
                    {step.icon}
                  </div>
                  <div data-id="element-291">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-292">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-gray-600" data-id="element-293">{step.description}</p>
                  </div>
                </div>
                {index < steps.length - 1 && <div className="ml-7 mt-4 flex justify-center" data-id="element-294">
                    <ArrowRight className="h-6 w-6 text-primary transform rotate-90" data-id="element-295" />
                  </div>}
              </div>)}
          </div>
          <div className="mt-12 text-center" data-id="element-296">
            <a href="#services" className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors" data-id="element-297">
              Explore Our Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}